import { render, staticRenderFns } from "./core-transactions.vue?vue&type=template&id=b277d6e6"
import script from "./core-transactions.vue?vue&type=script&lang=js"
export * from "./core-transactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports